import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { POST_CATEGORIES } from '@/constants'

const categories = [
  { id: 'all', name: '全部', color: 'bg-blue-500', path: '/' },
  ...POST_CATEGORIES.map(cat => ({
    id: cat.id,
    name: cat.name,
    color: 'bg-orange-500',
    path: `/category/${encodeURIComponent(cat.name)}`
  }))
]

interface CategoryTabsProps {
  selectedCategory: string
  onCategoryChange: (category: string) => void
  showAsLinks?: boolean
}

export function CategoryTabs({ selectedCategory, onCategoryChange, showAsLinks = false }: CategoryTabsProps) {
  const location = useLocation()

  return (
    <div className="bg-white rounded-lg p-4 lg:p-6 shadow-sm">
      <div className="flex space-x-2 lg:space-x-3 overflow-x-auto scrollbar-hide lg:flex-wrap lg:overflow-visible">
        {categories.map((category) => {
          const isSelected = showAsLinks 
            ? location.pathname === category.path
            : selectedCategory === category.name || (selectedCategory === '全部' && category.id === 'all')
          
          if (showAsLinks) {
            return (
              <Link
                key={category.id}
                to={category.path}
                className={cn(
                  "flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200",
                  isSelected
                    ? "bg-orange-500 text-white shadow-md"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                )}
              >
                {category.name}
              </Link>
            )
          }

          return (
            <button
              key={category.id}
              onClick={() => onCategoryChange(category.name)}
              className={cn(
                "flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200",
                isSelected
                  ? "bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow-md shadow-orange-500/25 scale-105"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              )}
            >
              {category.name}
            </button>
          )
        })}
      </div>
    </div>
  )
}